import PacienteCard from './PacienteCard';

const PacientesGrid = ({ pacientes, loading }) => (
  <div className="position-relative">
    {loading && (
      <div
        className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
        style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)', zIndex: 2 }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Carregando pacientes...</span>
        </div>
      </div>
    )}

    <div className={`row g-3 ${loading ? 'opacity-25 pointer-events-none' : ''}`}>
      {pacientes && pacientes.length > 0 ? (
        pacientes.map((paciente) => {
          const interventionDate = paciente.interventionStartDate
            ? new Date(paciente.interventionStartDate)
            : null;
          const hoje = new Date();
          hoje.setHours(0, 0, 0, 0);

          let mostrarBorda = null;

          if (interventionDate) {
            const dataLimite = new Date(interventionDate);
            dataLimite.setDate(dataLimite.getDate() + 30);
            dataLimite.setHours(0, 0, 0, 0);

            if (dataLimite >= hoje) {
              mostrarBorda = '#00FF00';
            }
          }
          if (!mostrarBorda && paciente.statusId === 1) {
            mostrarBorda = '#FE2E2E';
          }

          return (
            <PacienteCard
              key={paciente.id}
              paciente={paciente}
              mostrarBorda={mostrarBorda}
            />
          );
        })
      ) : (
        <div className="col-12">
          <div className="text-center text-secondary py-5">
            Nenhum paciente encontrado.
          </div>
        </div>
      )}
    </div>
  </div>
);

export default PacientesGrid;


